import { render } from "./Voters.vue?vue&type=template&id=179af97e&scoped=true"
import script from "./Voters.vue?vue&type=script&lang=ts"
export * from "./Voters.vue?vue&type=script&lang=ts"

import "./Voters.vue?vue&type=style&index=0&id=179af97e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-179af97e"

export default script